import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CONSTANTS from '../util/constants';
import APICallingService from '../services/APICallingService';

const RedirectToDashboard = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        APICallingService.navigate = location;
        const setData = async () => {
            if (location?.search) {
                let path = location?.search;
                let pathData = path.replace('?key=', '')
                await localStorage.setItem("L_R", pathData);
                dispatch({
                    type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_ROLES_MANAGEMENT_API_CALL
                });
                navigate('/Dashboard', { replace: true });
            }
            else {
                navigate('/', { replace: true });
            }
        }
        setData();
    }, [location]);
    return (
        <></>
    );
}

export default RedirectToDashboard;